if (!customElements.get('dibao-product-cta')) {
  customElements.define('dibao-product-cta', class extends HTMLElement {
    connectedCallback() {
      this.primary = this.closest('product-info')?.querySelector('.product__mobile-summary-cta-v40');
      if (!this.primary) return;

      this.mobile = window.matchMedia('(max-width: 749px)');
      this.controller = new AbortController();
      const options = { passive: true, signal: this.controller.signal };
      this.schedule = () => {
        if (this.frame !== undefined) return;
        this.frame = window.requestAnimationFrame(() => {
          this.frame = undefined;
          this.updateVisibility();
        });
      };
      window.addEventListener('scroll', this.schedule, options);
      window.addEventListener('resize', this.schedule, options);
      window.addEventListener('pageshow', this.schedule, options);
      this.addEventListener('focusout', this.schedule, { signal: this.controller.signal });
      this.mobile.addEventListener('change', this.schedule, { signal: this.controller.signal });
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.schedule);
        this.observer.observe(this.primary);
        const header = document.querySelector('.section-header');
        if (header) this.observer.observe(header);
      }
      this.updateVisibility();
    }

    updateVisibility() {
      const rect = this.primary.getBoundingClientRect();
      const header = document.querySelector('.section-header');
      const headerRect = header?.getBoundingClientRect();
      const headerBottom = headerRect && headerRect.top <= 0 && headerRect.bottom > 0
        ? Math.min(window.innerHeight, headerRect.bottom)
        : 0;
      const primaryVisible = rect.width > 0 && rect.height > 0
        && rect.bottom > headerBottom && rect.top < window.innerHeight;
      const shouldHide = this.mobile.matches && primaryVisible;
      if (shouldHide && this.contains(document.activeElement)) return;
      this.hidden = shouldHide;
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      if (this.frame !== undefined) window.cancelAnimationFrame(this.frame);
    }
  });
}
